import { Exclude, Expose, Type } from 'class-transformer';
import {
  BusinessConstitution,
  BusinessOwnership,
  CASE_BUSINESS_ACTIVITY,
  CASE_BUSINESS_ADDRESS_TYPE,
  CASE_BUSINESS_CLASSIFICATION,
  CASE_BUSINESS_COMPANY_TYPE,
  CASE_BUSINESS_NTB_ETB,
  CASE_BUSINESS_PREMISE_OWNERSHIP,
} from '../types';
import { BaseModel } from '../models';

@Exclude()
export class CaseBusinessAddressAttr {}

@Exclude()
export class CaseBusinessAddressDto extends BaseModel {
  @Expose()
  type!: CASE_BUSINESS_ADDRESS_TYPE;

  @Expose()
  @Type(() => CaseBusinessAddressAttr)
  attrs!: CaseBusinessAddressAttr;
}

@Exclude()
export class CreateCaseBusinessDto extends BaseModel {
  @Expose()
  businessClassification!: CASE_BUSINESS_CLASSIFICATION;

  @Expose()
  businessClassificationOther!: string;

  @Expose()
  countryId!: number;

  @Expose()
  natureOfBusiness!: string;

  @Expose()
  commencementDateOnly!: string;

  @Expose()
  businessActivity!: CASE_BUSINESS_ACTIVITY;

  @Expose()
  businessActivityOther!: string;

  @Expose()
  numberOfEmployee!: number;

  @Expose()
  isSameAsRegisteredAddress!: boolean;

  @Expose()
  officeContactAreaCode!: string;

  @Expose()
  officeContactNumber!: string;

  @Expose()
  officeFaxAreaCode!: string;

  @Expose()
  officeFaxNumber!: string;

  @Expose()
  businessPremiseOwnership!: CASE_BUSINESS_PREMISE_OWNERSHIP;

  @Expose()
  monthlyRental!: number;

  @Expose()
  gstRegistered!: boolean;

  @Expose()
  propertyCorporation!: boolean;

  @Expose()
  companyProfitable!: boolean;

  @Expose()
  usCorporation!: boolean;

  @Expose()
  participateIndirectly!: boolean;

  @Expose()
  usIndicia!: boolean;

  @Expose()
  email!: string;

  @Expose()
  ntbETB!: CASE_BUSINESS_NTB_ETB;

  @Expose()
  bankingGroup!: string;

  @Expose()
  originatingUnit!: string;

  @Expose()
  centricName!: string;

  @Expose()
  businessConstitution!: BusinessConstitution;

  @Expose()
  businessOwnership!: BusinessOwnership;

  @Expose()
  businessStatus!: string;

  @Expose()
  businessExpiryDateOnly!: string;

  @Expose()
  secondaryNatureOfBusiness!: string;

  @Expose()
  remark!: string;

  @Expose()
  metadata!: object;

  @Expose()
  addresses!: CaseBusinessAddressDto[];

  @Expose()
  businessType!: string;

  @Expose()
  companyType!: CASE_BUSINESS_COMPANY_TYPE;

  @Expose()
  dateOfIncorporationOnly!: Date;
}
